import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-signs",
  "use": "foquz-icon-signs-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-signs\"><path d=\"M4 13a2 2 0 01-2-2V9L1 8l1-1V5a2 2 0 012-2m9 10a2 2 0 002-2V9l1-1-1-1V5a2 2 0 00-2-2M7 13l3-10\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol